// ImagePopup.js
import React from "react";

const ImagePopup = ({ imageSrc, altText, onClose }) => {
  if (!imageSrc) return null;

  return (
    <div
      className="fixed inset-0 bg-black/70 flex items-center justify-center z-[1000]"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="relative bg-white rounded-2xl shadow-2xl max-w-[90vw] max-h-[90vh] flex items-center justify-center overflow-hidden p-4"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={imageSrc}
          alt={altText || "Popup Image"}
          className="max-w-full max-h-[80vh] object-contain"
        />
        <button
          className="absolute top-3 right-3 text-3xl text-red-500 hover:text-red-700 font-bold leading-none"
          onClick={onClose}
          aria-label="Close popup"
        >
          &times;
        </button>
      </div>
    </div>
  );
};

export default ImagePopup;
